import { SalesReportTotalSales } from '../types/salesReportTotalSales'

const HUNDRED_PERCENT = 100

const isValidNumber = (value: unknown): value is number => typeof value === 'number' && !isNaN(value)

const roundToPrecision = (value: number): number => {
  return Math.round(value * HUNDRED_PERCENT) / HUNDRED_PERCENT
}

export const calculateTotalSales = (salesReport: SalesReportTotalSales[]): SalesReportTotalSales => {
  const totals = salesReport.reduce<SalesReportTotalSales>(
    (totalReportValue, item) => {
      if (isValidNumber(item.grossTotal)) {
        totalReportValue.grossTotal += item.grossTotal
      }

      if (isValidNumber(item.netTotal)) {
        totalReportValue.netTotal += item.netTotal
      }

      return totalReportValue
    },
    { grossTotal: 0, netTotal: 0 },
  )

  return {
    grossTotal: roundToPrecision(totals.grossTotal),
    netTotal: roundToPrecision(totals.netTotal),
  }
}
